import React from 'react'
import { FormattedNumber } from '../FormattedNumber'

export const FormattedPercent = (props) => {
  return <FormattedNumber value={props.value / 100} maximumFractionDigits={2} style="percent" />
}
